import { GET_FLASH_SALE, POST_FLASH_SALE, PUT_FLASH_SALE } from '../type'
const initialState = {
  detailFlashSale: null
}

const flashSaleRedux = (state = initialState, action) => {
  switch(action.type) {
    case GET_FLASH_SALE:
      return {
        ...state,
        detailFlashSale: action.data
      }
    case POST_FLASH_SALE:
      return {
        ...state
      }
    case PUT_FLASH_SALE:
      return {
        ...state,
        detailFlashSale: action.data.data
      }
    default:
      return state
  }
}

export default flashSaleRedux